import React from 'react'
import PPVTemplate from 'src/components/page/ppv'

export default (props) => {
  const heroCTAs = [
    {
      text: 'Comprar: El Salvador vs Surinam',
      offerCode: 'us-rc-ga-elsalv_v_sur_250610-ppv-1',
    },
    {
      text: 'Comprar: Honduras vs Antigua',
      offerCode: 'us-rc-ga-hond_v_ant-250610-ppv-1',
    },
  ]

  return (
    <PPVTemplate
      lang="es"
      market="us"
      location={props.location}
      title="Eliminatorias CONCACAF Mundial 2026"
      subtitle={`En vivo martes 10 de junio en Fubo con pay per view`}
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/LP_PPV_CONCACAF_WCQ.mp4'}
      heroCTAs={heroCTAs}
      isEventEnded={true}
    />
  )
}
